import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import { WorkOrderService } from "../../../services/index";
import { throwMatDuplicatedDrawerError } from "@angular/material";

@Component({
  selector: "ocr-print",
  templateUrl: "./jobOcrPrint.html",
})
export class jobOcrPrint implements OnInit {
  @Output() partyUpdateEvent = new EventEmitter();
  tabTitle: string;
  tabID: string;
  mode: string;
  @Input() partydata: any = [];
  partyList: any = [];
  list: any = [];
  agentList: any = [];
  designList: any = [];
  printdata: any = {};
  woGrTot : number = 0;
  woGrTotMtr : number = 0;
  wodata: any = {};
  dataList : any = [];
  balData : any = [];
  woDetails : any;
  alphabet: string[];
  predefCol : number;
  userDefCol : number;
  cuttingRatio : number;
  woCons : number;
  maxColor : number;
  toDay : any;
  @Input() set printdt(val: any[]) {
    this.printdata = val;
    console.log(this.printdata);
    this.getDesignList(this.printdata.rgrn_id);
    
  }

  isLoading: boolean = false;
  @ViewChild("partyForm") partyForm;
  orderfromdtControl: FormControl = new FormControl();
  ordertodtControl: FormControl = new FormControl();
  salesfromdtControl: FormControl = new FormControl();
  salestodtControl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();

  constructor(
    public store: Store<fromRootStore.State>,
    private woservice: WorkOrderService,
    public bsModalRef: BsModalRef,
    public toasterService: ToasterService,
    public datePipe: DatePipe
  ) {}

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
    }, 100);
  }

  getDesignList(wd_id) {
    let params = {
      wd_id : wd_id
    };
    let that = this;
    that.woservice.getOcrPrint(params).then((res: any) => {
      /*   res.data = res.data.concat(res.data).concat(res.data).concat(res.data).concat(res.data).concat(res.data).concat(res.data).concat(res.data);  */
      that.dataList = res.data;
      that.balData = res.bal_data;

      that.dataList.forEach(element => {
        that.dataList[0].wo_cons = ((element.fab_mtr) / (element.wo_qty)).toPrecision(3);
        that.dataList[0].avg_cons = ((element.fab_mtr) / (element.ac_qty)).toPrecision(3);
        let wodate = element.wo_date.split('-');
        let deldate = element.del_date.split('-');
        let woDate = new Date(wodate[2], wodate[1] - 1, wodate[0]); 
        let delDate = new Date(deldate[2], deldate[1] - 1, deldate[0]);
        var Difference_In_Time = delDate.getTime() - woDate.getTime(); 
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);  
        that.dataList[0].age = Difference_In_Days;
      });
      let todate = new Date();
      this.toDay = todate.getDate() + '-' + (todate.getMonth() + 1) + '-' + todate.getFullYear();
    //   let list = [],
    //     list2 = [],
    //     count = 0;
    //   for (let i = 0; i < res.data.length; i++) {
    //     const li = res.data[i];
    //     list2.push(li);
    //     count++;
    //     if (count >= 5) {
    //       list.push([].concat(list2));
    //       list2 = [];
    //       count = 0;
    //     }
    //   }
    //   if (list2.length) {
    //     list.push([].concat(list2));
    //   }
    //   this.list = list;
    //   // this.calcRate();
    //   let f36_tot = 0,
    //     f38_tot = 0,
    //     f40_tot = 0,
    //     f42_tot = 0,
    //     f44_tot = 0,
    //     f46_tot = 0,
    //     h36_tot = 0,
    //     h38_tot = 0,
    //     h40_tot = 0,
    //     h42_tot = 0,
    //     h44_tot = 0,
    //     h46_tot = 0;
    //   for (let i = 0; i < res.data.length; i++) {
    //     let des = res.data[i];
    //     f36_tot += des.f36;
    //     f38_tot += des.f38;
    //     f40_tot += des.f40;
    //     f42_tot += des.f42;
    //     f44_tot += des.f44;
    //     f46_tot += des.f46;
    //     h36_tot += des.h36;
    //     h38_tot += des.h38;
    //     h40_tot += des.h40;
    //     h42_tot += des.h42;
    //     h44_tot += des.h44;
    //     h46_tot += des.h46;
    //   }
    //   this.printdata["f36_tot"] = f36_tot;
    //   this.printdata["f38_tot"] = f38_tot;
    //   this.printdata["f40_tot"] = f40_tot;
    //   this.printdata["f42_tot"] = f42_tot;
    //   this.printdata["f44_tot"] = f44_tot;
    //   this.printdata["f46_tot"] = f46_tot;
    //   this.printdata["h36_tot"] = h36_tot;
    //   this.printdata["h38_tot"] = h38_tot;
    //   this.printdata["h40_tot"] = h40_tot;
    //   this.printdata["h42_tot"] = h42_tot;
    //   this.printdata["h44_tot"] = h44_tot;
    //   this.printdata["h46_tot"] = h46_tot;
    });
  }

  print(div) {
    var content = document.getElementById(div).innerHTML;

    var mywindow = window.open("", "Print", "height=850,width=1000");

    /*mywindow.document.write('<html><head><title>Print</title>');
    mywindow.document.write('</head><body >');*/
    mywindow.document.write(content);
    //   mywindow.document.write('</body></html>');

    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/jobworkorder/jobOcrPrint.ts